var n = /* @__PURE__ */ ((t) => (t.NONE = "none", t.IMAGE = "cta-image", t.BOTTOM_CENTER_BUTTON = "bottom-center-button", t))(n || {});
export {
  n as CTAType
};
//# sourceMappingURL=enum.js.map
